var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import translations from './translations';
import * as dayjs from 'dayjs';
import css from './style.pcss';
var RTLNewsTicker = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLNewsTicker, _LitElement);
  function RTLNewsTicker() {
    var _this;
    _classCallCheck(this, RTLNewsTicker);
    _this = _callSuper(this, RTLNewsTicker);
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    _this.language = 'lu';
    _this.count = 8; // Default 50
    _this.updateCount = 8; // Default 50
    _this.updateInterval = 30000; // Default 30000
    _this.isLoading = false;
    _this.showMore = true;
    _this.articleList = [];
    if (window.rtlsites) {
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
      _this.language = window.rtlsites.config.language;
    }
    _this.location = window.location.origin;
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
    }
    return _this;
  }
  _createClass(RTLNewsTicker, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLNewsTicker.prototype), "connectedCallback", this).call(this);
      if (this.id) {
        this._fetchData();
      }
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getLastUpdate",
    value: function _getLastUpdate(elm) {
      var lastUpdateContainer = elm.querySelector('.js-lastupdate');
      if (lastUpdateContainer) {
        this.lastupdate = lastUpdateContainer.innerHTML;
        lastUpdateContainer.parentNode.removeChild(lastUpdateContainer);
      }
    }
  }, {
    key: "_getTotal",
    value: function _getTotal(elm) {
      var totalContainer = elm.querySelector('.js-total');
      if (totalContainer) {
        this.totalCount = totalContainer.innerHTML;
        totalContainer.parentNode.removeChild(totalContainer);
      }

      //console.log('COUNT: ' + this.count);
      //console.log('TOTALCOUNT: ' + this.totalCount);
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this._apiUrl = `${this.location}/livetickers/${this.id}?count=${this.count}`;
      //this.lastupdate = dayjs().format('YYYY-MM-DD HH:mm:ss');
      this.isLoading = true;
      fetch(this._apiUrl).then(function (resp) {
        return resp.text();
      }).then(function (resp) {
        _this2.data = resp;
        _this2.isLoading = false;
      }).catch(function (e) {
        console.log(e);
      });
      this.interval = setInterval(this._fetchUpdates.bind(this), this.updateInterval);
    }
  }, {
    key: "_fetchUpdates",
    value: function _fetchUpdates() {
      var _this3 = this;
      this._apiUrl = `${this.location}/livetickers/${this.id}?since=${this.lastupdate}&count=${this.count}`;
      var now = dayjs().format('YYYY-MM-DD HH:mm:ss');
      //console.log("Fetch Data - Last Update: " + this.lastupdate + " - Now: " + now);

      fetch(this._apiUrl).then(function (resp) {
        return resp.text();
      }).then(function (resp) {
        if (resp) {
          var fragment = document.createDocumentFragment();
          var liveticker = _this3.querySelector('.js-liveticker');
          var el = document.createElement('div');
          el.innerHTML = resp;
          el.classList.add('liveticker__fragment');
          fragment.appendChild(el);
          _this3._getLastUpdate(el);
          _this3._getTotal(el);
          var articles = fragment.querySelectorAll('.liveticker-a');
          if (_this3.totalCount >= _this3.count) _this3.showMore = true;
          var last;

          //console.log("ARTICLELIST", articles);

          if (_this3.articleList.length > 0) {
            _this3.articleList.forEach(function (article) {
              var currentArticle = Array.from(articles).find(function (node) {
                return node.isEqualNode(article);
              });
              if (!currentArticle) {
                document.getElementById(article.getAttribute("id")).parentElement.remove();
              }
            });
          }
          _this3.articleList = [];
          articles.forEach(function (article) {
            var existingArticle = document.getElementById(article.id);
            _this3.articleList.push(article);
            if (existingArticle) {
              if (article.dataset.lastupdate !== existingArticle.dataset.lastupdate) {
                //console.log(article.dataset.lastupdate);
                //console.log(existingArticle.dataset.lastupdate);
                existingArticle.parentNode.replaceChild(article, existingArticle);
              }
              last = existingArticle;
            } else {
              if (last) {
                last.parentNode.insertAdjacentElement('afterend', article.parentElement);
              } else {
                liveticker.prepend(article.parentElement);
              }
            }
          });
        }
        window.rtlsites.galleries.loadGalleries();
        twttr.ready(function (twttr) {
          twttr.widgets.load();
        });
        if (instgrm) instgrm.Embeds.process();
      }).catch(function (e) {
        console.log(e);
      });
    }
  }, {
    key: "_showMore",
    value: function _showMore() {
      this.count = this.count + this.updateCount;
      clearInterval(this.interval);
      this._fetchData();
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));
      this.updateComplete.then(function () {
        //console.log("UPDATED");
        if (_this4.isLoading === false) {
          _this4._getLastUpdate(_this4);
          _this4._getTotal(_this4);
          if (_this4.count >= _this4.totalCount) _this4.showMore = false;
          if (window.twttr) {
            window.twttr.ready(function (twttr) {
              twttr.widgets.load();
            });
          }
          if (window.instgrm) window.instgrm.Embeds.process();
          if (window.InfogramEmbeds) window.InfogramEmbeds.process();
          if (window.rtlsites.galleries) window.rtlsites.galleries.loadGalleries();
          if (window.tiktokEmbed) {
            var tiktoksOnPage = Array.from(document.querySelectorAll('blockquote.tiktok-embed'));
            if (typeof window.tiktokEmbed !== 'undefined' && tiktoksOnPage.length) {
              window.tiktokEmbed.lib.render(tiktoksOnPage);
            }
          }
        }
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
          if (Didomi.isConsentRequired()) {
            // Consent is required: your visitor is from the EU or you are an EU company
            // Only enable the vendor when consent is given
            var didomiTags = document.querySelectorAll(`[data-consent="didomi"]`);
            if (didomiTags) {
              didomiTags.forEach(function (tag) {
                //console.log(tag);
                //console.log(Didomi.getUserConsentStatusForVendor(tag.dataset.vendor));
                if (Didomi.getUserConsentStatusForVendor(tag.dataset.vendor)) {
                  if (tag.dataset.src) {
                    tag.src = tag.dataset.src;
                    tag.removeAttribute('data-src');
                  }
                } else {
                  tag.remove();
                }
              });
            }
          }
        });
      });
      return html(_t2 || (_t2 = _`
            <style>${0}</style>

            <div class="liveticker js-liveticker">
            ${0}
            </div>

            ${0}
        `), css, unsafeHTML(this.data), this.showMore === true ? html(_t3 || (_t3 = _`
                <div class="liveticker__more">
                    <div class="button-default-co${0}" @click=${0}>
                        ${0}

                    </div>
                </div>
            `), this.isLoading === true ? ` button-default-co--loading` : ``, function () {
        return _this4._showMore();
      }, this.isLoading === true ? html(_t4 || (_t4 = _`
                            <span class="liveticker__loading">Loading...</span>
                        `)) : html(_t5 || (_t5 = _`
                            <span>${0}</span>
                        `), this._getTranslation('more'))) : ``);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        id: {
          type: Number
        },
        data: {
          type: String
        },
        isLoading: {
          type: Boolean
        },
        totalCount: {
          type: Number
        },
        showMore: {
          type: Boolean
        },
        count: {
          type: Number
        },
        updateCount: {
          type: Number
        },
        articleList: {
          type: Array
        }
      };
    }
  }]);
  return RTLNewsTicker;
}(LitElement);
export { RTLNewsTicker as default };
window.customElements.define('rtl-newsticker', RTLNewsTicker);